// Shared services config — single source of truth
// `value` is the canonical dropdown value used in ContactForm Select AND
// passed as the `?service=` query param from ServicesPage cards.

export const SERVICES = [
  {
    key: "composite-decking",
    value: "Composite decking",
    title: "Composite Decking",
    tag: "Low maintenance",
    description:
      "UV-stable, splinter-free composite boards that look great year-round and don’t need oiling. A smart choice for busy Melbourne households.",
    image:
      "https://images.pexels.com/photos/19135427/pexels-photo-19135427.jpeg?auto=compress&cs=tinysrgb&w=1200&h=900&fit=crop",
    alt: "Composite decking boards installed in a Melbourne backyard",
  },
  {
    key: "merbau-decking",
    value: "Merbau decking",
    title: "Merbau Decking",
    tag: "Premium hardwood",
    description:
      "Rich, warm Australian hardwood with a deep natural grain. Classic timber look with the longevity of a premium deck.",
    image:
      "https://images.unsplash.com/photo-1721134118563-d47cb5db8164?auto=format&fit=crop&w=1200&q=80",
    alt: "Merbau timber decking with a warm natural finish",
  },
  {
    key: "pergolas",
    value: "Pergola",
    title: "Pergolas",
    tag: "Outdoor living",
    description:
      "Custom pergolas designed for Melbourne weather — shade in summer, light in winter. Perfect to pair with a new deck.",
    image:
      "https://images.pexels.com/photos/7587884/pexels-photo-7587884.jpeg?auto=compress&cs=tinysrgb&w=1200&h=900&fit=crop",
    alt: "Modern timber pergola over a backyard patio",
  },
  {
    key: "artificial-turf",
    value: "Artificial turf",
    title: "Artificial Turf",
    tag: "Green all year",
    description:
      "Premium synthetic lawn installation. No mowing, no watering, and a lush, consistent look through every Melbourne season.",
    image:
      "https://images.pexels.com/photos/33404118/pexels-photo-33404118.jpeg?auto=compress&cs=tinysrgb&w=1200&h=900&fit=crop",
    alt: "Freshly installed artificial turf lawn",
  },
  {
    key: "natural-turf",
    value: "Natural turf",
    title: "Natural Turf",
    tag: "Real grass lawn",
    description:
      "Real turf laid and levelled properly — sir walter buffalo, couch and kikuyu options available. Perfect if you want a traditional, living lawn in your Melbourne backyard.",
    image:
      "https://images.pexels.com/photos/1643389/pexels-photo-1643389.jpeg?auto=compress&cs=tinysrgb&w=1200&h=900&fit=crop",
    alt: "Lush green natural grass lawn in a modern Melbourne backyard",
  },
  {
    key: "landscaping",
    value: "Landscaping",
    title: "Landscaping",
    tag: "Full makeovers",
    description:
      "From concept to finish — paths, retaining walls, plantings, and the little details that turn a backyard into an outdoor room.",
    image:
      "https://images.pexels.com/photos/10177216/pexels-photo-10177216.jpeg?auto=compress&cs=tinysrgb&w=1200&h=900&fit=crop",
    alt: "Landscaped backyard with modern planting design",
  },
  {
    key: "garden-beds",
    value: "Garden beds / Outdoor features",
    title: "Garden Beds / Outdoor Features",
    tag: "Finishing touches",
    description:
      "Timber-edged garden beds, feature walls, planters and custom outdoor features built to tie the whole space together.",
    image:
      "https://images.pexels.com/photos/5302581/pexels-photo-5302581.jpeg?auto=compress&cs=tinysrgb&w=1200&h=900&fit=crop",
    alt: "Raised timber garden bed with fresh plantings",
  },
];

// Values shown in the contact form Select (plus an "Other" fallback).
export const FORM_SERVICE_VALUES = [
  ...SERVICES.map((s) => s.value),
  "Other",
];
